import React, { useState } from "react";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { UpdateLimit } from "../../../pages";
import { MoneyExController } from "../../../controllers";

const UpdateLimitContainer = ({ closeModal, item }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    daily: yup.array().of(
      yup.object().shape({
        currencyCode: yup.string().required("Currency code is required"),
        value: yup
          .number()
          .positive("Value must be positive")
          .required("Value is required"),
      })
    ),
    weekly: yup.array().of(
      yup.object().shape({
        currencyCode: yup.string().required("Currency code is required"),
        value: yup
          .number()
          .positive("Value must be positive")
          .required("Value is required"),
      })
    ),
    monthly: yup.array().of(
      yup.object().shape({
        currencyCode: yup.string().required("Currency code is required"),
        value: yup
          .number()
          .positive("Value must be positive")
          .required("Value is required"),
      })
    ),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      daily: values.daily,
      weekly: values.weekly,
      monthly: values.monthly,
    };
    const { status, errorMessage } = await MoneyExController.updateLimit(
      payload,
      item._id
    );
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    } else {
      setLoading(false);
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    return;
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];
  return (
    <UpdateLimit
      item={item}
      loading={loading}
      currencyCodes={currencyCodes}
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    />
  );
};
export default UpdateLimitContainer;
